import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Parameter {
    isOpen: boolean;
    id?: string;
}

type HandlerType = Handler<Parameter>;

export const DispatchSetSpoolModalOpen: HandlerType = props => {
    props.dispatch({
        type: "Custom/SetSpoolModal/CompleteSetIsOpen",
        isOpen: props.parameter.isOpen,
        id: props.parameter.id,
    } as any);
};

export const chain = [DispatchSetSpoolModalOpen];

const setSpoolModalOpen = createHandlerChainRunner(chain, "SetSpoolModalOpen");
export default setSpoolModalOpen;
